
import { nettoyerAnamnese } from '@/utils/anamnese-modes'
export default {
    name: 'historique-anamneses',
    components: {},
    props: {
        historique: Object
    },
    data() {
        return {

        }
    },
    computed: {

    },
    mounted() {

    },
    methods: {
        nettoyerAnamnese,

    }
}


